<template>
  <div v-loading="$wait.waiting(_uid)" class="card show-group">
    <div class="card-content">
      <div class="text-right wrapper-button control-button-wrapper pt-xxs">
        <router-link :to="{ name: 'companies_groups@index' }">
          <button type="button" class="btn btn-cancel btn-primary btn-wd">
            Back
          </button>
        </router-link>

        <acl :permissions="['companies_groups_update']">
          <button
            class="btn btn-info btn-fill btn-wd submit-button"
            @click.prevent="handleEditGroup"
          >
            Edit
          </button>
        </acl>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h5 class="text-info">
            <b>Profile</b>
          </h5>
        </div>

        <div class="col-xs-12">
          <b>Name</b>
          <ul class="list-unstyled mt-xxxs">
            <li>
              {{ model.name }}
            </li>
          </ul>
          <hr />
        </div>

        <div class="col-xs-12">
          <h5 class="text-info">
            <b>Profile</b>
          </h5>
        </div>

        <div class="col-xs-12">
          <b>Training Manager </b>
          <ul class="list-unstyled mt-xs">
            <li v-for="manager in model.managers" :key="manager.id">
              <router-link
                :to="{
                  name: 'companies_users@show',
                  params: { id: manager.id },
                }"
              >
                <b>{{ manager.name }}</b>
              </router-link>
            </li>
          </ul>

          <hr />
        </div>
        <div class="col-xs-12">
          <div class="card-content">
            <div class="mt-s">
              <div class="mb-5 w-full">
                <fieldset>
                  <div class="form-group">
                    <input
                      v-model="searchQuery"
                      type="search"
                      class="form-control form-search"
                      placeholder="Type to find what you are looking for"
                      aria-controls="datatables"
                      autofocus
                    />
                  </div>
                </fieldset>
              </div>

              <div>
                <el-table
                  class="table-striped first-row-clicable"
                  :data="queriedData"
                  :default-sort="defaultSort"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    sortable
                    :sort-orders="['ascending', 'descending']"
                    prop="fullName"
                    label="Name"
                  >
                    <template #default="scope">
                      <router-link
                        :to="{
                          name: 'companies_users@show',
                          params: { id: scope.row.id },
                        }"
                      >
                        {{ scope.row.fullName }}
                      </router-link>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- <div class="flex justify-between items-center">
                <div>
                  <p class="category">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                  </p>
                </div>

                <p-pagination
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="pagination.total"
                />

                <div>
                  <el-select
                    v-model="pagination.perPage"
                    class="select-default"
                    placeholder="Per page"
                  >
                    <el-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      class="select-default"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import PPagination from "@components/UIComponents/Pagination.vue";
import { Table, TableColumn } from "element-ui";
import _get from "lodash.get";
import Vue from "vue";
import tableConfig from "@providers/table";
import joinByName from "@helpers/joinByName";
import _cloneDeep from "lodash.clonedeep";
import { mapGetters, mapState, mapActions } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
export default {
  components: {
    //PPagination,
  },
  data() {
    const model = {};

    const table = {
      tableColumns: [
        // {
        //   prop: "rpe",
        //   label: "Registry, Purpose, Equipment",
        //   minWidth: 200
        // },
        // {
        //   prop: "roles",
        //   label: "Roles",
        //   minWidth: 200
        // }
      ],
    };

    return {
      model,
      ...table,
      ...tableConfig.data,
      defaultSort: { prop: "fullName", order: "ascending" },
    };
  },
  computed: {
    ...mapState("companyGroupStore", ["group"]),
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    tableData() {
      const trainees = _get(this, "model.trainees", []);

      return trainees.map((trainee) => ({
        ...trainee,
        rpe: joinByName(trainee.company.rpe),
        roles: joinByName(trainee.company.roles),
      }));
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const groupId = _get(this, "$route.params.id");
      await this.getCompanyGroupById(groupId);
      this.model = _cloneDeep(this.group);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("companyGroupStore", ["getCompanyGroupById"]),
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    handleRowClick(row, column) {
      if (column.label !== "Name") {
        return;
      }

      this.$router.push({
        name: "companies_users@show",
        params: { id: row.id },
      });
    },
    handleEditGroup() {
      return this.$router.push({
        name: "companies_groups@edit",
        params: { id: this.group.id },
      });
    },
    cancelShow() {
      return this.$router.push({ name: "companies_groups@index" });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/paper/variables";
.btn-cancel {
  margin: 0 12px;
}

@media (max-width: 1024px) {
  .wrapper-button .btn {
    width: 100%;
  }
  .btn-cancel {
    margin: 12px 0;
  }
}
</style>
